var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 4C3.01367 4 2 5.01367 2 6.25V18.25C2 19.4863 3.01367 20.5 4.25 20.5H20.75C21.9863 20.5 23 19.4863 23 18.25V6.25C23 5.01367 21.9863 4 20.75 4H4.25ZM4.25 5.5H20.75C20.8027 5.5 20.8438 5.51758 20.8906 5.5293L12.5 11.3359L4.10938 5.5293C4.15625 5.51758 4.19727 5.5 4.25 5.5ZM3.5 6.92969L12.5 13.1641L21.5 6.92969V18.25C21.5 18.6719 21.1719 19 20.75 19H4.25C3.82812 19 3.5 18.6719 3.5 18.25V6.92969Z",
    fill: "#454A54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.08e3fd433d3b92b1c4d4b9fba6248aa6.svg";
export { ForwardRef as ReactComponent };